export default __webpack_public_path__ + "static/media/logo_fmfa.8d493a40.png";